import React, { useEffect, useState } from "react";
import { Grid, Typography, Box } from "@material-ui/core";
import { MemoryRounded } from "@material-ui/icons";
import lodash from "lodash";

import MainLayout from "../components/Layout/MainLayout";
import SensorBoardTable from "../components/SensorBoard/Table";
import { firebaseFetchOneFactory } from "../firebase/factory";
import LoadingState from "../components/Custom/LoadingState";
import { firebaseFetchOneDealer } from "../firebase/dealer";

export default function FactoryDetailPage(props) {
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  const { dealerID, factoryID } = props;

  /**
  |--------------------------------------------------
  | States
  |--------------------------------------------------
  */
  const [errorCode, setErrorCode] = useState(null);
  const [factory, setFactory] = useState(null);
  const [dealer, setDealer] = useState(null);
  const [devices, setDevices] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isMobile] = useState(window.screen.availWidth < 640 ? true : false);

  /**
  |--------------------------------------------------
  | Fetch One Fectory
  |--------------------------------------------------
  */
  useEffect(() => {
    fetchOneFactory();
  }, []);

  async function fetchOneFactory() {
    try {
      const dealer = await firebaseFetchOneDealer(dealerID);

      if (!dealer) {
        setErrorCode(404);
        return;
      }

      setDealer(dealer);

      const factory = await firebaseFetchOneFactory(factoryID);

      if (!factory) {
        setErrorCode(404);
        return;
      }

      if (factory.provider !== dealerID) {
        setErrorCode(404);
        return;
      }

      setFactory(factory);
      setDevices(lodash.map(factory.devices, (s, key) => ({ ...s, id: key })));
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  }
  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  if (errorCode) {
    return (
      <MainLayout
        errorCode={errorCode}
        dealerID={dealerID}
        factoryID={factoryID}
      />
    );
  }

  if (loading) {
    return (
      <MainLayout dealerID={dealerID} factoryID={factoryID}>
        <Grid container spacing={4}>
          <Grid item lg={12} xs={12}>
            <LoadingState />
          </Grid>
        </Grid>
      </MainLayout>
    );
  }

  /**
  |--------------------------------------------------
  | Breadcrumbs
  |--------------------------------------------------
  */
  const breadcrumbs = [
    {
      to: "/",
      label: "Dashboard",
    },
    { to: `/${dealerID}`, label: dealer.name },
    { to: null, label: factory.factory.name },
  ];

  return (
    <MainLayout
      breadcrumbs={breadcrumbs}
      dealerID={dealerID}
      factoryID={factoryID}
      className="overflow-hidden"
    >
      <Grid item lg={12} xs={12}>
        {/* FACTORY DETAIL HEADER */}
        <Grid item xs={12}>
          <Grid container justify="space-between" alignItems="center">
            <Typography variant="h5">{factory.factory.name}</Typography>
            <Grid item xs={12}>
              <Grid container>
                <Box color="grey.600" mr={2}>
                  <Typography>Factory Key:</Typography>
                </Box>
                <Box>
                  <Typography>{factoryID}</Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/* FACTORY DETAIL HEADER */}

        {/* SENSOR BOARD CARD */}
        <Grid item lg={12} xs={12}>
          <Box bgcolor="grey.800" p={3} borderRadius="borderRadius">
            <Grid container spacing={3}>
              {/* TABLE MENU */}
              <Grid
                item
                xs={12}
                container
                justify="space-between"
                alignItems="center"
              >
                <Grid item xs={6} container>
                  <Box color="grey.600" mr={1}>
                    <MemoryRounded />
                  </Box>
                  <Typography>Sensor Boards</Typography>
                </Grid>
              </Grid>
              {/* TABLE MENU */}

              <Grid item className="w-full max-w-sm lg:max-w-full ">
                {loading ? (
                  <LoadingState />
                ) : (
                  <div className="overflow-x-scroll sm:overflow-hidden">
                    <SensorBoardTable
                      sensors={devices}
                      dealerID={dealerID}
                      factoryID={factoryID}
                      isMobile={isMobile}
                      fetchOneFactory={fetchOneFactory}
                    />
                  </div>
                )}
              </Grid>
            </Grid>
          </Box>
        </Grid>
        {/* SENSOR BOARD CARD */}
      </Grid>
    </MainLayout>
  );
}
